module.exports = __webpack_public_path__ + "static/img/zip.8d61a7f3.png";